<p-dialog [header]="forLocation ? 'Set Map Location' : 'Override Device Location'" [visible]="_visible()" [modal]="true" [closable]="false" (onShow)="initMap()" (onHide)="close()" [style]="{ width: '44rem', maxHeight: '90vh' }">
    <div class="flex flex-col gap-3">
        <p class="text-sm text-color-secondary m-0">
            @if (forLocation) {
            Set the map location for <strong>{{ targetLabel() }}</strong>. Rooms and control systems below it use this position unless they set their own.
            } @else {
            Set the map location for <strong>{{ targetLabel() }}</strong>. This overrides the position it inherits from its room or building.
            }
        </p>

        <div class="flex gap-2">
            <input pInputText type="text" class="grow" placeholder="Search for an address or place…" [ngModel]="searchText()" (ngModelChange)="searchText.set($event)" (keydown.enter)="search()" [disabled]="busy()" />
            <p-button label="Search" icon="pi pi-search" (onClick)="search()" [loading]="searching()" [disabled]="busy() || !searchText().trim()"></p-button>
        </div>

        <div #mapContainer class="geo-map"></div>

        <div class="flex items-end gap-3">
            <div class="flex flex-col gap-1">
                <label class="text-xs text-color-secondary" for="geo-lat">Latitude</label>
                <input pInputText id="geo-lat" type="number" step="0.000001" min="-90" max="90" [ngModel]="latitude()" (ngModelChange)="latitude.set($event)" (change)="onCoordInput()" [disabled]="busy()" class="coord-input" />
            </div>
            <div class="flex flex-col gap-1">
                <label class="text-xs text-color-secondary" for="geo-lng">Longitude</label>
                <input pInputText id="geo-lng" type="number" step="0.000001" min="-180" max="180" [ngModel]="longitude()" (ngModelChange)="longitude.set($event)" (change)="onCoordInput()" [disabled]="busy()" class="coord-input" />
            </div>
            @if (address()) {
            <div class="text-sm text-color-secondary pb-2 truncate" [title]="address()!">{{ address() }}</div>
            }
        </div>

        <p class="text-xs text-color-secondary m-0">Tip: click the map or drag the pin to fine-tune the position.</p>

        @if (error()) {
        <div class="text-status-offline text-sm">{{ error() }}</div>
        }
    </div>

    <ng-template #footer>
        <div class="flex gap-2 w-full">
            @if (hasOverride) {
            <p-button [label]="forLocation ? 'Inherit from parent' : 'Clear Override'" [icon]="forLocation ? 'pi pi-undo' : 'pi pi-trash'" severity="danger" [outlined]="true" (onClick)="clearOverride()" [disabled]="busy()"></p-button>
            }
            <div class="grow"></div>
            <p-button label="Cancel" severity="secondary" [text]="true" (onClick)="close()" [disabled]="busy()"></p-button>
            <p-button label="Save Location" icon="pi pi-check" (onClick)="save()" [disabled]="!canSave()" [loading]="busy()"></p-button>
        </div>
    </ng-template>
</p-dialog>
